import React from 'react';
import clsx from 'clsx';

// prop types
interface IconProps {
    className?: string;
    iconColor?: 'white' | 'orange' | 'primary' | 'text-dark' | 'text-light';
    iconSide?: 'left' | 'right';
    iconSize?: 'xs' | 'sm' | 'md' | 'lg';
    IconComponent?: React.ElementType | string;
}

export default function IconWrapper({ className, iconColor, iconSide, iconSize, IconComponent }: IconProps) {
    return (
        <span className={clsx(
            'icon',
            // icon color
            iconColor === 'white' && 'icon-white',
            iconColor === 'primary' && 'icon-primary',
            iconColor === 'orange' && 'icon-orange',
            iconColor === 'text-dark' && 'icon-text-dark',
            iconColor === 'text-light' && 'icon__light',

            // icon side
            iconSide === 'left' && 'iconLeft',
            iconSide === 'right' && 'iconRight',

            // icon size
            iconSize === 'xs' && 'icon-xs',
            iconSize === 'sm' && 'icon-sm',
            iconSize === 'md' && 'icon-md',
            iconSize === 'lg' && 'icon-lg',


            className
        )}>
            <IconComponent />
        </span>
    );
}
